import { Reducer } from "../../lib/redux";
import { ICredentialsWithServer } from "../../utils/credentialsStore";
import { extend } from "../../utils/vanilla";
import { DriveAPICredentialsActions } from "./actions";
import { DriveAPICredentialsActionTypes } from "./types";

export let defaultdriveAPICredentials: IIdDictionary<ICredentialsWithServer> = {};

export let driveAPICredentials: Reducer<IIdDictionary<ICredentialsWithServer>, DriveAPICredentialsActions> = (state = defaultdriveAPICredentials, action) => {
    switch (action.type) {
        case DriveAPICredentialsActionTypes.SET_DRIVE_API_CREDENTIALS: {
            const userName = action.payload.userName;
            const credentials = action.payload.credentials;
            const server = action.payload.server || "";
            const iamSettings = action.payload.iamSettings;
            if (credentials) {
                return {
                    ...state,
                    [userName]: {
                        credentials: extend(true, {}, credentials),
                        server,
                        iamSettings
                    }
                };
            }
            return state;
        }
        case DriveAPICredentialsActionTypes.CLEAR_DRIVE_API_USER_CREDENTIALS: {
            const userName = action.payload;
            let newState = { ...state };
            delete newState[userName];
            return newState;
        }
        case DriveAPICredentialsActionTypes.CLEAR_DRIVE_API_CREDENTIALS: {
            if (action.payload && action.payload.length > 0) {
                return Object.keys(state)
                    .filter(userName => action.payload.map(user => user.name).indexOf(userName) !== -1)
                    .reduce((curr, key) => ({
                        ...curr,
                        [key]: state[key]
                    }), {});
            }
            return {};
        }
        default:
            return state;
    }
};